import { FakeInput } from "../../../../../../layout/forms/FakeFormField";
import { SkeletonTable } from "../../../../../../layout/skeleton/SkeletonTable";

export const EventDivisionResultPageSkeleton = () => (
    <div className="skeleton">
        <FakeInput input={80} />
        <br />
        <br />
        <SkeletonTable />
    </div>
);
